import React from 'react'
import { Query } from 'react-apollo'
import VIDEO_QUERY from './video.query'
import PageLoader from 'components/PageLoader'
import VideoPlayerContainer from './video/components/VideoPlayerContainer'
import VideoPlayerContainerV2 from './video/components/VideoPlayerContainerV2'
import ReelFeedbackModal from './video/components/ReelFeedbackModal'
import Feature from 'components/Feature'
import TouchVideoLastViewedAtMutation from 'components/mutations/TouchVideoLastViewedAt'
import { flatten } from 'utils/fp'

const VideoShow = ({ videoId }) => (
  <Query query={VIDEO_QUERY} variables={{ videoId }}>
    {({ loading, data: { node: video }, ...rest }) =>
      loading ? (
        <PageLoader />
      ) : (
        <ReelFeedbackModal videoId={videoId}>
          {({ show }) => (
            <Feature
              name="demo_video_page"
              fallback={() => (
                <VideoPlayerContainer
                  clips={video.clips.edges.map(({ node }) => node)}
                  video={video}
                  show={show}
                />
              )}
              render={() => (
                <TouchVideoLastViewedAtMutation videoId={videoId}>
                  {({ touchLastViewedAt }) => (
                    <VideoPlayerContainerV2
                      clips={video.clips.edges.map(({ node }) => node)}
                      video={video}
                      show={show}
                      items={
                        video.transcript &&
                        flatten(video.transcript.rawTranscript.results.items)
                      }
                      touchLastViewedAt={touchLastViewedAt}
                    />
                  )}
                </TouchVideoLastViewedAtMutation>
              )}
            />
          )}
        </ReelFeedbackModal>
      )
    }
  </Query>
)

const RouteVideo = ({
  match: {
    params: { videoId }
  }
}) => <VideoShow videoId={videoId} />

export default RouteVideo



// WEBPACK FOOTER //
// ./src/routes/video.js